'use client';

import React from 'react';

const SkipLink: React.FC = () => {
  const focusNextAfterMain = () => {
    const main = document.querySelector('header');
    if (!main) return;

    const focusables = Array.from(
      document.querySelectorAll<HTMLElement>(
        'a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])',
      ),
    );

    const mainContentElement = focusables.find(
      (el) => !main.contains(el) && !!(main.compareDocumentPosition(el) & Node.DOCUMENT_POSITION_FOLLOWING),
    );
    mainContentElement?.focus();
  };

  return (
    <button
      className="z-1000 absolute -translate-y-full translate-x-4 transform rounded bg-white px-4 py-2 text-sm text-black shadow transition-transform duration-200 ease-out focus:translate-y-1"
      onClick={() => focusNextAfterMain()}
    >
      Skip to main content
    </button>
  );
};

export default SkipLink;
